module.exports = ".card{margin-left:1rem;margin-bottom:1rem;height:22rem}.card-header{padding:0.3rem;font-size:0.7rem;height:5rem}.card-body.main{padding:0.3rem;font-size:0.7rem}.card.manualform{width:10rem}.card-image-top{width:128px}.card-text{width:128px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dataentry/manualcreate.component.sass
// module id = ./src/app/modules/dashboard/dataentry/manualcreate.component.sass
// module chunks = main